import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Loading from 'modules/core/components/Loading'
import Modal from 'modules/core/components/Modal'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useTaxTypes } from 'modules/finance/hooks/useTaxTypes'

interface Props {
  id: number
  onClose: () => void
}

const DeleteTaxTypeModal = ({ id, onClose }: Props) => {
  const { deleteTaxType } = useTaxTypes([id])
  const [loading, setLoading] = React.useState<boolean>(false)

  const handleSubmit = async () => {
    setLoading(true)
    const response = await deleteTaxType(id)

    const handled = handleResult(response, () => {
      app.setFlash({ type: 'wrong', message: i18n.t('finance.modals.delete_tax_type.error') })
      track(trackingEvents.accounting.deleteTaxSubmit, { status: 'error' })
      setLoading(false)
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('finance.modals.delete_tax_type.success'),
      })
      track(trackingEvents.accounting.deleteTaxSubmit, { status: 'success' })
      onClose()
    }
  }

  return (
    <Modal
      illustration="delete"
      title={i18n.t('finance.modals.delete_tax_type.title')}
      description={i18n.t('finance.modals.delete_tax_type.description')}
      onClose={onClose}
      onSubmit={handleSubmit}
      footer={
        <Button disabled={loading} submit>
          {i18n.t('finance.buttons.delete')}
        </Button>
      }
    >
      {loading && <Loading />}
    </Modal>
  )
}

export default observer(DeleteTaxTypeModal)
